export const PACKAGE_SUB_MANAGE_KEYS = {
  ORDER: 'order',
  REQUEST_TYPE: 'orderType',
  TYPES: 'dataPackageName',
  DATE_REQUESTED: 'createDate',
  REQUEST_STATUS: 'status',
  PAYMENT_METHOD: 'paymentMethod',
  TOTAL: 'totalAmountVND',
  CONTRACT: 'contractFileUploaded',
  PAYMENT_STATUS: 'transactionStatus',
  DETAIL: 'id',
}

export const PACKAGE_SUB_MANAGE_TITLE = [
  { title: '#', key: PACKAGE_SUB_MANAGE_KEYS.ORDER },
  {
    title: 'userManagement.packageSubManagement.REQUEST_TYPES',
    key: PACKAGE_SUB_MANAGE_KEYS.REQUEST_TYPE,
  },
  {
    title: 'userManagement.packageSubManagement.TYPES',
    key: PACKAGE_SUB_MANAGE_KEYS.TYPES,
  },
  {
    title: 'userManagement.packageSubManagement.DATE_REQUESTED',
    key: PACKAGE_SUB_MANAGE_KEYS.DATE_REQUESTED,
  },
  {
    title: 'userManagement.packageSubManagement.REQUEST_STATUS',
    key: PACKAGE_SUB_MANAGE_KEYS.REQUEST_STATUS,
  },
  {
    title: 'userManagement.packageSubManagement.PAYMENT_METHOD',
    key: PACKAGE_SUB_MANAGE_KEYS.PAYMENT_METHOD,
  },
  {
    title: 'userManagement.packageSubManagement.TOTAL_VND',
    key: PACKAGE_SUB_MANAGE_KEYS.TOTAL,
  },
  {
    title: 'userManagement.packageSubManagement.CONTRACT',
    key: PACKAGE_SUB_MANAGE_KEYS.CONTRACT,
  },
  {
    title: 'userManagement.packageSubManagement.PAYMENT_STATUS',
    key: PACKAGE_SUB_MANAGE_KEYS.PAYMENT_STATUS,
  },
  {
    title: '',
    key: PACKAGE_SUB_MANAGE_KEYS.DETAIL,
  },
]

export const TYPE_PACKAGE_SUBSCRIPTION = {
  PACKAGE: 'Package',
  SUBSCRIPTION: 'Subscription',
  ALL: 'All',
  CONNECTION_MAP: 'ConnectionMap',
}

export const REQUEST_TYPE_FILTER = [
  {
    key: TYPE_PACKAGE_SUBSCRIPTION.ALL,
    label: 'userManagement.packageSubManagement.ALL',
    value: null,
    isI18n: true,
  },
  {
    key: TYPE_PACKAGE_SUBSCRIPTION.PACKAGE,
    label: 'userManagement.packageSubManagement.PACKAGE',
    value: TYPE_PACKAGE_SUBSCRIPTION.PACKAGE,
    isI18n: true,
  },
  {
    key: TYPE_PACKAGE_SUBSCRIPTION.SUBSCRIPTION,
    label: 'userManagement.packageSubManagement.SUBSCRIPTION',
    value: TYPE_PACKAGE_SUBSCRIPTION.SUBSCRIPTION,
    isI18n: true,
  },
  {
    key: TYPE_PACKAGE_SUBSCRIPTION.CONNECTION_MAP,
    label: 'userManagement.packageSubManagement.CONNECTION_MAP',
    value: TYPE_PACKAGE_SUBSCRIPTION.CONNECTION_MAP,
    isI18n: true,
  },
]

export const ALL_STATUS = {
  label: 'userManagement.packageSubManagement.ALL',
  value: null,
  isI18n: true,
}
